import {
    Alert, Avatar, Button, Card, Col, Divider, Image, Modal, Row, Select, Spin, Table, Tag, Timeline, Typography
} from 'antd';
import { Helmet } from 'react-helmet-async';
import { useEffect, useState } from 'react';
import { apiCall } from '../../API/RestApi';
import { modalError } from '../../Component/Modal/ModalLayout';
import { useSelector } from 'react-redux';
import Search from 'antd/es/input/Search';
import moment from 'moment';
import { dateFormat, dateFormatDate } from '../../Utils/formatDate';
import heic2any from "heic2any";

const { Option } = Select;
function DelegationLeavePaid() {
    const token = useSelector((state) => state.user.token);
    const [data, setData] = useState([]);
    const [search, setSearch] = useState('');
    const [loading, setLoading] = useState(false);
    const [statusFilter, setStatusFilter] = useState('');
    const [page, setPage] = useState({
        pagination: { current: 1, pageSize: 10 },
    });
    const [isAlert, setIsAlert] = useState(false);
    const [textAlert, setTextAlert] = useState('');
    const [detailData, setDetailData] = useState(null);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [convertedImages, setConvertedImages] = useState([]);

    useEffect(() => {
        const convertHeicImages = async () => {
            if (!detailData?.leave_paid_image) return;

            const results = await Promise.all(
                detailData.leave_paid_image.map(async (img) => {
                    try {
                        const url = img.image;

                        if (url?.toLowerCase().endsWith(".heic")) {
                            // 🔹 Ambil file HEIC dari URL (HTTPS)
                            const response = await fetch(url, { mode: "cors" });
                            const blob = await response.blob();

                            // 🔹 Konversi HEIC → JPEG
                            const converted = await heic2any({
                                blob,
                                toType: "image/jpeg",
                                quality: 0.9,
                            });

                            // 🔹 Ubah ke object URL biar bisa dipakai di <img>
                            return {
                                ...img,
                                convertedUrl: URL.createObjectURL(converted),
                            };
                        } else {
                            // 🔹 Kalau bukan HEIC, pakai URL asli
                            return { ...img, convertedUrl: url };
                        }
                    } catch (error) {
                        console.error("Gagal konversi HEIC:", error);
                        return { ...img, convertedUrl: img.image };
                    }
                })
            );

            setConvertedImages(results);
        };

        convertHeicImages();
    }, [detailData]);

    const columns = [
        {
            title: 'No',
            dataIndex: 'no',
            render: (_, __, index) => (page.pagination.current - 1) * page.pagination.pageSize + index + 1,
        },
        {
            title: 'User Code',
            dataIndex: 'users_code',
            render: (_, record) => record.users?.users_code || '-',
        },
        {
            title: 'Name',
            dataIndex: 'name',
            render: (_, record) => record.users?.name || '-',
        },
        {
            title: 'Description',
            dataIndex: 'desc',
        },
        {
            title: 'Start Date',
            dataIndex: 'date_start',
            render: (_, record) => moment(record.date_start).format('DD-MM-YYYY'),
        },
        {
            title: 'End Date',
            dataIndex: 'date_end',
            render: (_, record) => moment(record.date_end).format('DD-MM-YYYY'),
        },
        {
            title: 'Time Off Type',
            dataIndex: 'leave_type',
            render: (_, record) => {
                if (record.leave_type !== null) {
                    return record.leave_type.name
                } else {
                    return '-';
                }
            }
        },
        {
            title: 'Status',
            dataIndex: 'status',
            render: (_, record) => {
                switch (record.leave_paid_approval[0].status_approval_id) {
                    case 2: return <Tag color='green'>Approved</Tag>;
                    case 3: return <Tag color='red'>Rejected</Tag>;
                    default: return <Tag color='yellow'>{record.status}</Tag>;
                }
            },
        },
        {
            title: 'Created At',
            dataIndex: 'created_at',
            render: (_, record) =>
                record.created_at ? dateFormat(record.created_at) : '-',
        },
        {
            title: 'Action',
            dataIndex: 'action',
            render: (_, record) => {
                return (
                    <Button type="default" style={{ marginRight: 10 }} onClick={() => showDetailModal(record)}>
                        <b>Detail</b>
                    </Button>
                );
            },
        },
    ];

    function checkDelegation(item) {
        const items = item.leave_paid_approval;
        return items.length === 1 && items[0].status_approval_id === 1;
    }

    const getApi = (method, url, type) => {
        setLoading(true);
        apiCall({
            method,
            url,
            data: {
                headers: {
                    Authorization: 'Bearer ' + token,
                },
            },
        })
            .then((res) => {
                if (res.status === 'success') {
                    if (type === 'detail') {
                        setDetailData(res.data);
                        setIsModalVisible(true);
                    } else {
                        setData(res.data.data);
                        setPage({
                            ...page,
                            pagination: {
                                ...page.pagination,
                                total: res.data.total_data,
                            },
                        });
                    }
                }
                setLoading(false);
            })
            .catch((e) => {
                setLoading(false);
                console.error(e.message);
            });
    };

    const postApi = async (method, url, values) => {
        setLoading(true);
        setIsAlert(false);
        await apiCall({
            method,
            url,
            data: {
                data: values,
                headers: {
                    Authorization: 'Bearer ' + token,
                },
            },
        })
            .then((res) => {
                setLoading(false);
                if (res.status === 'success') {
                    setIsAlert(true);
                    setTextAlert(res.message);
                    getApi('GET', '/leavepaid?userdelegation=true&search=' + search + '&statusDelegation=' + statusFilter + '&page=1', 'leave_paid');
                    setSelectedRowKeys([]);
                } else {
                    modalError(res.message);
                }
            })
            .catch((e) => {
                setLoading(false);
                console.error(e.message);
            });
    };
    const showDetailModal = (data) => {
        getApi('GET', '/leavepaid/' + data.leave_paid_id, 'detail');
    };

    const bulkApproveOrReject = (status) => {
        Modal.confirm({
            title: `Confirm ${status === 2 ? 'Delegation' : 'Rejection'}`,
            content: `Are you sure you want to ${status === 2 ? 'approve' : 'reject'} ${selectedRowKeys.length} item(s)?`,
            onOk: () =>
                postApi('PUT', '/leavepaidapprovaldelegationbulk', {
                    ids: selectedRowKeys,
                    status_approval_id: status,
                    reason: status === 3 ? 'Rejected via bulk' : undefined,
                }),
        });
    };

    const handleTableChange = (pagination) => {
        setPage({ pagination });
    };

    const searchData = (value) => {
        setSearch(value);
        setPage({
            pagination: { current: 1, pageSize: 10 },
        });
    };

    const rowSelection = {
        selectedRowKeys,
        onChange: (newSelectedKeys) => {
            setSelectedRowKeys(newSelectedKeys);
        },
        getCheckboxProps: (record) => ({
            disabled: record.status !== 'Process' || !checkDelegation(record),
        }),
    };

    useEffect(() => {
        getApi('GET', '/leavepaid?userdelegation=true&search=' + search + '&statusDelegation=' + statusFilter + '&page=' + page.pagination.current, 'leave_paid');
    }, [JSON.stringify(page), isAlert, statusFilter]);


    return (
        <div>
            <Helmet>
                <title>Time Off Delegation Data</title>
            </Helmet>
            {isAlert && (
                <Alert
                    message={textAlert}
                    type="success"
                    banner
                    closable
                    afterClose={() => setIsAlert(false)}
                />
            )}
            <h3>Time Off Delegation Data</h3>
            <Row gutter={16} style={{ marginBottom: 16 }}>
                <Col span={8}>
                    <Search placeholder="Search" allowClear enterButton onSearch={searchData} />
                </Col>
                <Col span={8}>
                    <Select
                        placeholder="Filter by status"
                        allowClear
                        style={{ width: 160 }}
                        onChange={setStatusFilter}
                    >
                        <Option value="Process">Process</Option>
                        <Option value="Approved">Approved</Option>
                        <Option value="Rejected">Rejected</Option>
                    </Select>
                </Col>
                <Col span={8} style={{ textAlign: 'right' }}>
                    <Button
                        type="primary"
                        onClick={() => bulkApproveOrReject(2)}
                        disabled={selectedRowKeys.length === 0}
                        style={{ marginRight: 8 }}
                    >
                        Approved ({selectedRowKeys.length})
                    </Button>
                    <Button
                        type="primary"
                        danger
                        onClick={() => bulkApproveOrReject(3)}
                        disabled={selectedRowKeys.length === 0}
                    >
                        Rejected ({selectedRowKeys.length})
                    </Button>
                </Col>
            </Row>

            <Table
                rowKey="leave_paid_id"
                rowSelection={rowSelection}
                size="middle"
                columns={columns}
                dataSource={data}
                pagination={page.pagination}
                loading={loading}
                onChange={handleTableChange}
            />

            <Modal
                title="Time Off Detail"
                open={isModalVisible}
                onCancel={() => setIsModalVisible(false)}
                footer={null}
                width={900}
            >
                {loading ? (
                    <Spin tip="Loading..." />
                ) : (
                    detailData && (
                        <Card>
                            <Typography.Title level={5}>Time Off Information</Typography.Title>
                            <Row gutter={[16, 16]}>
                                <Col span={12}>
                                    <Typography.Text strong>Employee Name:</Typography.Text>
                                    <Typography.Paragraph>{detailData.users.name}</Typography.Paragraph>
                                </Col>
                                <Col span={12}>
                                    <Typography.Text strong>Time Off Type:</Typography.Text>
                                    <Typography.Paragraph>{detailData.leave_type.name}</Typography.Paragraph>
                                </Col>
                                <Col span={12}>
                                    <Typography.Text strong>Submission Date:</Typography.Text>
                                    <Typography.Paragraph>{new Date(detailData.date).toLocaleDateString()}</Typography.Paragraph>
                                </Col>
                                <Col span={12}>
                                    <Typography.Text strong>Status:</Typography.Text>
                                    <Typography.Paragraph>{detailData.status}</Typography.Paragraph>
                                </Col>
                                <Col span={24}>
                                    <Typography.Text strong>Description:</Typography.Text>
                                    <Typography.Paragraph>{detailData.desc || '-'}</Typography.Paragraph>
                                </Col>
                                <Col span={12}>
                                    <Typography.Text strong>Start Date:</Typography.Text>
                                    <Typography.Paragraph>{dateFormatDate(detailData.date_start)}</Typography.Paragraph>
                                </Col>
                                <Col span={12}>
                                    <Typography.Text strong>End Date:</Typography.Text>
                                    <Typography.Paragraph>{dateFormatDate(detailData.date_end)}</Typography.Paragraph>
                                </Col>
                            </Row>

                            <Divider />
                            <Typography.Title level={5}>Attachments</Typography.Title>
                            <Row gutter={[16, 16]}>
                                {convertedImages?.length > 0 ? (
                                    convertedImages.map((img) => (
                                        <Col key={img.leave_paid_image_id} span={6}>
                                            <Image
                                                src={img.convertedUrl}
                                                width={200}
                                                height={200}
                                                style={{ objectFit: "contain", borderRadius: "10px" }}
                                            />
                                        </Col>
                                    ))
                                ) : (
                                    <Col span={24}>
                                        <Typography.Text>No attachments</Typography.Text>
                                    </Col>
                                )}
                            </Row>

                            <Divider />
                            <Typography.Title level={5}>Delegation</Typography.Title>
                            <Timeline mode="left" style={{ marginTop: 20 }}>
                                {/* Requested */}
                                <Timeline.Item color="blue">
                                    <Row gutter={8} align="middle">
                                        <Col>
                                            <Avatar src={detailData.users?.image} />
                                        </Col>
                                        <Col>
                                            <Typography.Text strong>{detailData.users?.name || "-"}</Typography.Text><br />
                                            <Tag color="blue">Requested</Tag><br />
                                            <Typography.Text type="secondary" style={{ fontSize: 12 }}>
                                                {dateFormat(detailData.created_at) || "-"}
                                            </Typography.Text>
                                        </Col>
                                    </Row>
                                </Timeline.Item>

                                {/* Delegation Steps */}
                                {detailData.leave_paid_approval?.map((approval) => (
                                    <Timeline.Item
                                        key={approval.leave_paid_approval_id}
                                        color={
                                            approval.status_approval_id === 2
                                                ? "green"
                                                : approval.status_approval_id === 3
                                                    ? "red"
                                                    : "yellow"
                                        }
                                    >
                                        <Row gutter={8} align="middle">
                                            <Col>
                                                <Avatar src={approval.user?.image} />
                                            </Col>
                                            <Col>
                                                <Typography.Text strong>{approval.user?.name || "-"}</Typography.Text><br />
                                                {detailData.users?.users_id === approval.user?.users_id ? (
                                                    <Tag color="red">Canceled</Tag>
                                                ) : (
                                                    <Tag
                                                        color={
                                                            approval.status_approval_id === 2
                                                                ? "green"
                                                                : approval.status_approval_id === 3
                                                                    ? "red"
                                                                    : "yellow"
                                                        }
                                                    >
                                                        {approval.status_approval?.status}
                                                    </Tag>
                                                )}
                                                <br />
                                                <Typography.Text type="secondary" style={{ fontSize: 12 }}>
                                                    {dateFormat(approval.created_at) || "-"}
                                                </Typography.Text>
                                            </Col>
                                        </Row>
                                    </Timeline.Item>
                                ))}
                            </Timeline>
                        </Card>
                    )
                )}
            </Modal>
        </div>
    );
}

export default DelegationLeavePaid;
